
















import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
//import * as easings from 'vuetify/es5/util/easing-patterns'
import { EventBus } from "@/main";

@Component({
  computed: {
    options() {
      return {
        duration: this.$data.duration,
        offset: this.$data.offset,
        easing: this.$data.easing
      };
    }
  },
  data() {
    return {
      selector: "#first",
      selected: "Button",
      elements: ["Button", "Radio group"],
      duration: 500,
      offset: 768,
      easing: "linear",
      showFrom: 400,
      offsetTop: 0
    };
  },
  beforeMount() {
    EventBus.$on("app-scroll-event", (scroll: number) => {
      this.$data.offsetTop = scroll;
    });
  }
})
export default class ToTop extends Vue {}
